/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receiveOperations from './receive-operations';

export default (operationId) => (dispatch) => {
    
    dispatch({
        type: actions.OPERATIONS_REQUEST,
    });

    return cecSdk
        .operation(operationId)
        .cancel()
        .then((operations) => {
            dispatch({
                type: actions.OPERATIONS_REQUEST_SUCCESS,
            });
            dispatch(receiveOperations(operations));
            return operations;
        });

};
